export default "__VITE_ASSET__eef58a03__"